import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

/**
 * Layout pour les pages publiques (accueil, BBT token, etc.)
 * Ce layout n'utilise pas de connexion WebSocket ni de vérification d'authentification
 */
const PublicLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow flex flex-col">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default PublicLayout;
